let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2kJ7W")).then(() => parcelRequire('bp0jd'));